<template>
	<div class="pa-2">
		<v-row
			dense
		>
			<v-col cols="2">
				<v-text-field
					dense
					outlined
					:label="$T('inputs.name')"
					hide-details></v-text-field>
			</v-col>
	
			<v-col cols="10">
				<v-row class="" align="center">
					<v-col>
						<v-autocomplete 
							:items="[]"
							dense
							row
							hide-details
							label="المنصب الحالي"
							outlined
						/>
					</v-col>
					<v-col>
						<v-radio-group
							label="نوع التقييم"
							dense
							row
							hide-details
							class="mt-0">
							<v-radio
								label="سنوي"
								:value="0"></v-radio>
							<v-radio
								label="نص سنوي"
								:value="1"></v-radio>
						</v-radio-group>
					</v-col>
					فترة محدد :
					<v-col cols="2">
						<bee-date-picker
							input-label="من"
							:input-props="{ outlined: true, dense: true, prependInnerIcon: '$calendar' }"
							:months-over-max="5"
							menu-picker
							calendar
							no-title
							hide-details></bee-date-picker>
					</v-col>
					<v-col cols="2">
						<bee-date-picker
						input-label="إلى"
						:input-props="{ outlined: true, dense: true, prependInnerIcon: '$calendar' }"
						:months-over-max="5"
						menu-picker
						calendar
						no-title
						hide-details></bee-date-picker>

					</v-col>
				</v-row>
			</v-col>
		</v-row>

		<div class="">
			<v-row>
				<v-col cols="12" class="">
					<h4 class="">المهارات العامة</h4>
					<bee-handy-table
						:headers="headers"
						:items="items"
						dense
						zebra
						height="auto"
						:items-per-page="-1"
						fixed-header
						hide-default-footer
					>
						<template v-slot:item.value="{ item }">
					
							<v-radio-group
								v-model="item.value"
								row
								hide-details
								class="mt-0"
								:disabled="Boolean($route.query.preview)"
								small
							>
								<v-radio
									label="5%"
									:value="1"
								></v-radio>
								<v-radio
									label="25%"
									:value="2"
								></v-radio>
								<v-radio
									label="50%"
									:value="3"
								></v-radio>
								<v-radio
									label="75%"
									:value="4"
								></v-radio>
								<v-radio
									label="100%"
									:value="5"
								></v-radio>
							</v-radio-group>
						</template>

						<template v-slot:item.explain="{}">
							<v-text-field
								dense
								hide-details
							/>
						</template>
					</bee-handy-table>
				</v-col>
				<v-col class="py-1" cols="12">
					<v-textarea
						:label="$T('inputs.notes')"
						rows="3"
						outlined
						dense
						hide-details
						auto-grow></v-textarea>
				</v-col>
				<v-col cols="12" class="py-0">
					<h4 class="py-1"> حل المشاكل </h4>
					<bee-handy-table
						:headers="headers"
						:items="items2"
						dense
						zebra
						height="auto"
						:items-per-page="-1"
						fixed-header
						hide-default-footer
					>
						<template v-slot:item.value="{ item }">
							<v-radio-group
								v-model="item.value"
								row
								hide-details
								class="mt-0"
								:disabled="Boolean($route.query.preview)"
								small
							>
								<v-radio
									label="5%"
									:value="1"
								></v-radio>
								<v-radio
									label="25%"
									:value="2"
								></v-radio>
								<v-radio
									label="50%"
									:value="3"
								></v-radio>
								<v-radio
									label="75%"
									:value="4"
								></v-radio>
								<v-radio
									label="100%"
									:value="5"
								></v-radio>
							</v-radio-group>
						</template>

						<template v-slot:item.explain="{}">
							<v-text-field
								dense
								hide-details
							/>
						</template>
					</bee-handy-table>
				</v-col>

				<v-col class="py-0">
					<h4 class="py-1">جودة العمل</h4>
					<bee-handy-table
						:headers="headers"
						:items="items3"
						dense
						zebra
						height="auto"
						:items-per-page="-1"
						fixed-header
						hide-default-footer
					>
						<template v-slot:item.value="{ item }">
							<v-radio-group
								v-model="item.value"
								row
								hide-details
								class="mt-0"
								:disabled="Boolean($route.query.preview)"
								small
							>
								<v-radio
									label="5%"
									:value="1"
								></v-radio>
								<v-radio
									label="25%"
									:value="2"
								></v-radio>
								<v-radio
									label="50%"
									:value="3"
								></v-radio>
								<v-radio
									label="75%"
									:value="4"
								></v-radio>
								<v-radio
									label="100%"
									:value="5"
								></v-radio>
							</v-radio-group>
						</template>

						<template v-slot:item.explain="{}">
							<v-text-field
								dense
								hide-details
							/>
						</template>
					</bee-handy-table>
				</v-col>
			</v-row>


			<v-row dense class="mb-2 mt-4">
				<v-col cols="12">
					<v-textarea
					:label="$T('inputs.notes')"
					rows="3"
					outlined
					dense
					hide-details
					auto-grow></v-textarea>
				</v-col>
				<v-col cols="6">
					<v-textarea
						label="نقاط القوة"
						rows="7"
						outlined
						dense
						hide-details
						auto-grow></v-textarea>
				</v-col>
				<v-col cols="6">
					<v-textarea
						label="نقاط يجب تطويرها وتحسينها"
						rows="7"
						outlined
						dense
						hide-details
						auto-grow></v-textarea>
				</v-col>
				<v-col cols="12">
					<v-textarea
						label="تعليقات الموظف"
						rows="3"
						outlined
						dense
						hide-details
						auto-grow></v-textarea>
				</v-col>
			</v-row>
		</div>
	</div>
</template>

<script>
export default {
	name: 'EmployeePerformance',

	data() {
		return {
			items: [
				{
					name: 'القدرة على تحديد الاحتياجات اللازمة للعمل',
					value: 0,
					explain: ''
				},
				{
					name: 'القدرة على إعداد خطط العمل',
					value: 0,
					explain: ''
				},

				{
					name: 'تنفيذ االخطط والبرامج بنجاح وفي الوقت المحدد',
					value: 0,
					explain: ''
				},
				{
					name: 'القدرة على توزيع العمل على الموظفين',
					value: 0,
					explain: ''
				},
				{
					name: 'القدرة على تنفيذ العمل حسب الاولويات',
					value: 0,
					explain: ''
				},
				{
					name: 'القدرة على اعداد تقارير العمل وتقديمها إلى ادارته',
					value: 0,
					explain: ''
				},
				{
					name: 'القدرة على حل المشكلات',
					value: 0,
					explain: ''
				},
				{
					name: 'القدرة على اتخاذ القرارات الصائبة',
					value: 0,
					explain: ''
				},
				{
					name: 'الحيادية في حل المشكلات',
					value: 0,
					explain: ''
				},
				{
					name: 'القدرة على تحفيز الموظفين',
					value: 0,
					explain: ''
				},

				{
					name: 'لديه مهارات تواصل',
					value: 0,
					explain: ''
				},
				{
					name: 'القدرة على تطوير أداء الموظفين',
					value: 0,
					explain: ''
				},
				{
					name: 'قدرت التأثير على الموظفين لتحقيق الأهداف',
					value: 0,
					explain: ''
				},
				{
					name: 'القدرة على أداء العمل دون توجيه تعليمات مفصلة',
					value: 0,
					explain: ''
				},
				{
					name: 'القدرة على تنفيذ العمل بجودة',
					value: 0,
					explain: ''
				},
				{
					name: 'الالتزام بتسليم المنجزات المطلوبة في مواعيدها',
					value: 0,
					explain: ''
				},
				{
					name: 'الالتزام بتعليمات العمل',
					value: 0,
					explain: ''
				},
				{
					name: 'تقبل توجيهات الرئيس المباشر',
					value: 0,
					explain: ''
				},
				{
					name: 'التعامل باحترام ومهنية مع الرؤساء وزملاء العمل',
					value: 0,
					explain: ''
				},
				{
					name: 'تنفيذ ما يكلف به من مهام دون تذمر أو شكوى',
					value: 0, 
					explain: ''
				}
			],

			items2: [
				{
					name: 'القدرة على حل المشكلات',
					value: 0,
					explain: ''
				},
				{
					name: 'القدرة على اتخاذ القرارات الصائبة',
					value: 0,
					explain: ''
				},
				{
					name: 'الحيادية في حل المشكلات',
					value: 0,
					explain: ''
				}
				
			],
			items3: [
				{
					name: 'القدرة على أداء العمل دون توجيه تعليمات مفصلة',
					value: 0,
					explain: ''
				},
				{
					name: 'القدرة على تنفيذ العمل بجودة',
					value: 0,
					explain: ''
				},
				{
					name: 'الالتزام بتسليم المنجزات المطلوبة في مواعيدها',
					value: 0,
					explain: ''
				}	
			]
		};
	},

	computed: {
		headers() {
            return [
                {
                    text: '',
                    name: 'Name',
                    value: 'name',
                },
                {
                    text: '',
                    name: 'value',
                    value: 'value'
                },
                {
                    text: 'ملاحظة',
                    name: 'explain',
                    value: 'explain',
                    width: '40%'
                }
            ]
        }
	}
};
</script>

<style lang="scss">
.interview .v-input--radio-group__input {
	justify-content: space-between;
}
</style>
